import { useState, useEffect } from "react";
import { useRecoilValue } from "recoil";
import Header from "../../../components/header";
import { isApp } from "../../../hooks/useNativeApp";
import useScreenOrientation from "../../../hooks/useScreenOrientation";
import { insetState } from "../../../recoil/inset";
import {
  ReservationButtonWrapper,
  ReservationInfo,
  ReservationInfoWrapper,
  ReservationStateButton,
  ReservationWrapper,
} from "./style";
import { useReservation } from "./hooks/use-reservation";
import ImageViewerModal from "../../../components/common/ImageViewerModal";
import OpenApp from "../../../components/openApp";
import { shareURL } from "../../../utils/common";
import ReservationStateModal from "./components/state";
import { Overlay } from "../OddsCalc/styles";
import ReservationOptionModal from "./components/option";
import ReservationConfirmModal from "./components/confirm";
import useDialog from "../../../hooks/useDialog";
import { TournamentType } from "../../../dataset";
import { CurrentReservationType } from "../../../api/reservation";

const Reservation = () => {
  const hook = useReservation();
  const {
    // 핸들러
    handleCancel,
    handleReservation,
    // 데이터
    reservation,
    pub,
    isReservation,
    currentList,
    setType,
  } = hook;
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [isOptionOpen, setIsOptionOpen] = useState(false);
  const [isStateOpen, setIsStateOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [isOpenUseApp, setIsOpenUseApp] = useState(false);
  const orientation = useScreenOrientation();
  const { openDialog } = useDialog();
  const inset = useRecoilValue(insetState);

  useEffect(() => {
    if (!isApp && orientation !== "landscape") {
      setIsOpenUseApp(true);
    }
  }, []);

  const goToApp = () => {
    if (!isApp) {
      const isKakao = /KAKAOTALK/i.test(navigator.userAgent);
      const redirectUrl =
        window.location.href +
        (window.location.search ? "&" : "?") +
        "store_redirect=true";
      // 앱 실행 시도
      if (isKakao) {
        window.location.href =
          "kakaotalk://web/openExternal?url=" + encodeURIComponent(redirectUrl);
      } else {
        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
        if (isIOS) {
          const link = document.createElement("a");
          link.href = redirectUrl;
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          window.open(redirectUrl, "_blank");
          window.close();
        }
      }
      return;
    }
  };

  useEffect(() => {
    // URL에서 store_redirect 파라미터 확인
    const params = new URLSearchParams(window.location.search);
    const shouldRedirect = params.get("store_redirect");

    if (shouldRedirect === "true" && !isApp) {
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      if (isIOS) {
        window.location.href = "https://apps.apple.com/app/6469495456";
      } else {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.runnersoft.runnerrunner";
      }
    }
  }, []);

  const infos = [
    { name: "매장 이름", value: pub?.pubName },
    { name: "주소", value: pub?.newAddress },
    { name: "매장번호", value: pub?.vcn },
  ];

  const handleButton = () => {
    if (isReservation) {
      openDialog({
        title: "예약취소",
        type: "web",
        text: "해당 토너먼트 예약을 취소 하시겠습니까?",
        cancelText: "닫기",
        confirmColor: "#D91818",
        confirm: true,
        onConfirm: handleCancel,
      });
    } else {
      if (reservation?.tournamentType === TournamentType.TimeAttack) {
        handleReservation(CurrentReservationType.NORMAL);
        return;
      }
      setIsOptionOpen(true);
    }
  };

  return (
    <ReservationWrapper inset={inset}>
      <ImageViewerModal
        isOpen={!!selectedImage}
        onClose={() => setSelectedImage(null)}
        imageUrl={selectedImage || ""}
      />
      {isOpenUseApp && (
        <OpenApp openApp={goToApp} onClose={() => setIsOpenUseApp(false)} />
      )}
      {isStateOpen && (
        <ReservationStateModal
          onClose={() => setIsStateOpen(false)}
          currentList={currentList}
        />
      )}
      {isOptionOpen && (
        <ReservationOptionModal
          onClose={() => setIsOptionOpen(false)}
          hook={hook}
          setIsConfirmOpen={setIsConfirmOpen}
        />
      )}
      {isConfirmOpen && (
        <ReservationConfirmModal
          onClose={() => setIsConfirmOpen(false)}
          hook={hook}
        />
      )}
      {(isStateOpen || isOptionOpen || isConfirmOpen) && <Overlay />}

      <Header
        title={pub?.pubName || ""}
        buttonClick={() => shareURL(window.location.href, reservation?.title)}
        img="/image-web/reservation/new_share_button.svg"
      />
      <img
        src={reservation?.imageUrl || ""}
        alt="poster"
        onClick={() => setSelectedImage(reservation?.imageUrl || "")}
      />
      <ReservationInfoWrapper>
        <div className="title">{reservation?.title}</div>
        <ReservationInfo>
          {infos.map((info, index) => (
            <div className="row" key={index}>
              <div className="name">{info.name}</div>
              <div className="value">{info.value}</div>
            </div>
          ))}
        </ReservationInfo>
        <div className="warning">※미인증 계정은 예약이 불가능합니다.</div>
      </ReservationInfoWrapper>
      <ReservationButtonWrapper>
        <ReservationStateButton onClick={() => setIsStateOpen(true)}>
          <img src="/image-web/reservation/state_button.svg" alt="To Map" />
          <div className="state">{currentList.length}명</div>
        </ReservationStateButton>
        <div
          className={`button ${isReservation ? "cancel" : ""}`}
          onClick={handleButton}
        >
          {isReservation ? "예약취소" : "토너먼트 예약하기"}
        </div>
      </ReservationButtonWrapper>
    </ReservationWrapper>
  );
};

export default Reservation;
